export const OUTLET_BLOCK = 'outletBlock';
export const OUTLET_SANITY_TYPE = 'SanityOutletBlock';
